import React, { useState } from "react";
import { Link } from "react-router-dom";
import profilePicture from "../assets/profile-picture.jpg";
import "./About.css";
import { Helmet } from "react-helmet";

const hobbies = [
  {
    number: "01",
    label: "Reading",
    accomplishment: "I am reading \"at the existensialist cafe\". ",
  },
  {
    number: "02",
    label: "Learning languages",
    accomplishment: "Completed Intermediate II (Dutch B1) with the Delftse methode. Learning French now.",
  },
  {
    number: "03",
    label: "Running",
    accomplishment: "Ran the marathon here.",
    link: "https://uitslagen.nl/uitslag?id=2025113009236",
    linkLabel: "here",
  },
];

const focusAreas = [
  {
    title: "Research",
    description: "I am building toward a PhD focused on stochastic analysis, and the theory of neural networks.",
  },
  {
    title: "Engineering",
    description: "I like to apply theory in practice, so that I combine math, modeling, and software in one place.",
  },
  {
    title: "Writing",
    description: "I use this site to collect work, projects, and the themes I am thinking about.",
  },
];

const highlights = [
  "MSc student in Applied Mathematics at TU Delft",
  "Interested in stochastics, mean-field analysis, and machine learning theory",
  "Also drawn to neuroscience, philosophy, and endurance training",
];

const timeline = [
  {
    period: "Nov 2024 - Sep 2026",
    title: "MSc — Applied Mathematics",
    place: "Technical University of Delft, Delft",
  },
  {
    period: "Sep 2021 - Nov 2024",
    title: "Double BSc — Applied Mathematics & Computer Science",
    place: "University of Twente, Enschede",
  },
];

const awards = [
  {
    title: "Illiad Intensive ML Program",
    description: "Selected for the Illiad intensive machine learning program in San Francisco, with a $5,000 stipend.",
  },
];

const recentNews = [
  "01/11/2026 - Starting my internship at Inria on heavy tails with Umut Simsekli.",
  "28/09/2026 - Defended my thesis on the \"Mean-field Analysis of Dropout Neural Networks\".",
  "01/02/2026 - Started my thesis on the meanfield analysis of dropout neural networks.",
  "01/06/2025 - Started my internship at VORtech with a project at the Rijkswaterstaat"

];

const socialLinks = [
  {
    label: "Google Scholar",
    href: "https://scholar.google.com/citations?hl=en&authuser=1&user=c3yOqLYAAAAJ",
  },
  {
    label: "GitHub",
    href: "https://github.com/yazanmashal03",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/yazan-mash-al-236a88220/",
  },
  {
    label: "X",
    href: "https://twitter.com/yazanmashal03",
  },
  {
    label: "Email",
    href: "mailto:yazanmashal03@gmail.com",
  },
];

function About() {
  const [expandedHobby, setExpandedHobby] = useState(null);

  const toggleHobby = (label) => {
    setExpandedHobby((current) => (current === label ? null : label));
  };

  return (
    <div className="about-page page-shell">
      <Helmet>
        <title>Yazan Mash'Al</title>
      </Helmet>

      <section className="home-intro" aria-labelledby="home-title">
        <h1 id="home-title"><strong>Yazan</strong> Mash&apos;Al</h1>
        <div className="home-intro__body">
          <div>
            <p className="lead">I am Yazan Mash&apos;Al, a research Intern at Inria (Paris).</p>
            <ul className="intro-facts">
              {highlights.slice(1).map((item) => <li key={item}>{item}</li>)}
            </ul>
            <p className="intro-links"><Link to="/research">Research</Link><Link to="/projects">Projects</Link><a href="/blog/">Writing</a></p>
            <div className="social-links">
              {socialLinks.map((link) => <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer">{link.label}</a>)}
            </div>
          </div>
          <img src={profilePicture} alt="Yazan Mash'Al" className="profile-image" />
        </div>
      </section>

      <section className="home-section" aria-labelledby="news-heading">
        <h2 id="news-heading">News</h2>
        <ul className="news-list">
          {recentNews.map((item) => {
            const [date, ...description] = item.split(" - ");
            return <li key={item}><time dateTime={date.split("/").reverse().join("-")}>{date}</time><span>{description.join(" - ")}</span></li>;
          })}
        </ul>
      </section>

      <section className="home-section" aria-labelledby="education-heading">
        <h2 id="education-heading">Education</h2>
        <div className="education-list">
          {timeline.map((item) => <div key={item.title}><p className="education-period">{item.period}</p><div><h3>{item.title}</h3><p>{item.place}</p></div></div>)}
        </div>
      </section>

      <section className="home-section" aria-labelledby="awards-heading">
        <h2 id="awards-heading">Awards</h2>
        {awards.map((award) => <p key={award.title}>{award.description}</p>)}
      </section>

      <section className="home-section" aria-labelledby="hobbies-heading">
        <h2 id="hobbies-heading">Away from work</h2>
        <div className="hobby-list">
          {hobbies.map((hobby) => <div key={hobby.label}>
            <button type="button" onClick={() => toggleHobby(hobby.label)} aria-expanded={expandedHobby === hobby.label} aria-controls={`hobby-${hobby.number}`}>
              <span aria-hidden="true">{expandedHobby === hobby.label ? "−" : "+"}</span> {hobby.label}
            </button>
            <div id={`hobby-${hobby.number}`} hidden={expandedHobby !== hobby.label}>
              <p>{hobby.link ? <>Ran the marathon <a href={hobby.link} target="_blank" rel="noopener noreferrer">{hobby.linkLabel}</a>.</> : hobby.accomplishment}</p>
            </div>
          </div>)}
        </div>
      </section>
    </div>
  );
}

export default About;
